import { Button, Pagination, Table } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  clearPaymentQuery,
  purchaseHistoryRequest,
  setPaymentQuerytData,
} from '@/actions/payment';
import Link from 'next/link';
import Loader from '../common/Spinner';
import axios from 'axios';

const PurchaseHistoryComponent = () => {
  const dispatch = useDispatch();
  const paymentReducer = useSelector((state: any) => state.payment);
  const [receiptStatus, setReceiptStatus] = useState('');
  const [purchaseID, setPurchaseID] = useState('');

  useEffect(() => {
    dispatch(clearPaymentQuery());
    return () => {};
  }, []);
  const {
    purchaseHistory: { data, meta, getPurchaseHistoryStatus },
    query: { purchaseHistory },
  } = paymentReducer;

  useEffect(() => {
    dispatch(purchaseHistoryRequest({ data: purchaseHistory }));
  }, [JSON.stringify([purchaseHistory.page, purchaseHistory.per_page])]);

  const svgImageObj = [
    {
      name: 'Discover',
      src: 'https://www.udemy.com/staticx/udemy/images/v9/card-discover.svg',
    },
    {
      name: 'Mastercard',
      src: 'https://www.udemy.com/staticx/udemy/images/v9/card-mastercard.svg',
    },
    {
      name: 'Visa',
      src: 'https://www.udemy.com/staticx/udemy/images/v9/card-visa.svg',
    },
  ];

  const downloadPdf = (each) => {
    setPurchaseID(each?.id);
    setReceiptStatus('request');
    try {
      axios
        .get(`${process.env.NEXT_PUBLIC_BASE_URL}generate-receipt/${each?.id}`, {
          responseType: 'blob',
          headers: {
            Authorization: `${localStorage.getItem('token')}`,
          },
        })
        .then((response) => {
          let url = window.URL.createObjectURL(new Blob([response.data]));
          let link = document.createElement('a');
          link.href = url;
          link.setAttribute(
            'download',
            `${
              each?.order?.course
                ? each?.order?.course?.title
                : each?.order?.room
                ? each?.order?.room?.title
                : each?.order?.mocktest?.title
            } payment receipt.pdf`
          );
          document.body.appendChild(link);
          link.click();
          setReceiptStatus('success');
        });
    } catch (error) {
      setReceiptStatus('failure');
    }
  };

  const dataSource = data.map((each, index) => ({
    sn:
      getPurchaseHistoryStatus === 'success'
        ? `${(purchaseHistory.page - 1) * purchaseHistory.per_page + index + 1}`
        : '',
    key: each.id,
    name:
      each?.order?.course || each?.order?.room || each?.order?.mocktest ? (
        <Link
          href={
            each?.order?.course
              ? `/course/${each?.order?.course?.slug}`
              : each?.order?.room
              ? `/room/${each?.order?.room?.slug}`
              : `/mock-test/${
                  each?.order?.mocktest?.test_type == 'LISTENING'
                    ? 'listening'
                    : each?.order?.mocktest?.test_type == 'WRITING'
                    ? 'writing'
                    : each?.order?.mocktest?.test_type == 'READING'
                    ? 'reading'
                    : each?.order?.mocktest?.test_type == 'SPEAKING'
                    ? 'speaking'
                    : 'normal'
                }/${each?.order?.mocktest?.slug}`
          }
        >
          <a
            className="font-size-sm cursor-pointer text-black text-capitalize"
            style={{ fontWeight: '500' }}
          >
            {each?.order?.course
              ? each?.order?.course?.title
              : each?.order?.room
              ? each?.order?.room?.title
              : each?.order?.mocktest?.title}
          </a>
        </Link>
      ) : (
        ''
      ),
    order_type: (
      <span className="text-muted pt-2 font-size-sm text-capitalize">
        {each?.order_type === 'COURSE' ? 'Course' : each?.order_type}
      </span>
    ),

    amount: (
      <span className="price text-muted font-size-sm">
        {each?.currency}
        {each.amount}
      </span>
    ),
    paytment_type: (
      <span className="text-muted pt-2 font-size-sm">
        {' '}
        {each?.paytment_type === 'ESEWA' ? (
          <img
            src="/images/esewa_logo_1.webp"
            style={{ width: '60px', height: '20px' }}
            alt="esewa"
            className="mt-1"
          />
        ) : each?.paytment_type === 'KHALTI' ? (
          <img
            src="/images/khalti_logo.webp"
            style={{ width: '60px', height: '20px' }}
            alt="khalti"
            className="mt-1"
          />
        ) : each?.paytment_type === 'STRIPE' ? (
          <div className="d-flex flex-nowrap">
            {svgImageObj?.map((svg) => (
              <img
                title={svg?.name}
                className="border ml-1"
                src={svg?.src}
                style={{ width: '40px', height: '28px' }}
                alt={svg?.name}
              />
            ))}
          </div>
        ) : (
          each?.paytment_type === 'INTERNAL' && 'Free Coupon'
        )}
      </span>
    ),
    status: (
      <div className="d-flex justify-content-center text-muted">
        <span className="text-left">{each.order?.status}</span>{' '}
        {(each.order?.status === 'Cancel' || each.order?.status === 'Success') && (
          <img
            src={
              each.order?.status === 'Cancel'
                ? '/images/multiply.svg'
                : each.order?.status === 'Success'
                ? '/images/check.svg'
                : ''
            }
            style={{ width: '28px', height: '18px' }}
            alt={'icon'}
          />
        )}
      </div>
    ),
    date: (
      <span className="text-muted" style={{ fontSize: '11px' }}>
        {each?.date}
      </span>
    ),
    invoice:
      each?.paytment_type !== 'INTERNAL' && each.order?.status === 'Success' ? (
        <Button
          disabled={receiptStatus === 'request' && each?.id === purchaseID}
          size="middle"
          className="btn-outline-primary border-danger"
          onClick={() => downloadPdf(each)}
        >
          <span className="d-flex justify-content-between">
            Receipt{' '}
            {receiptStatus === 'request' && each?.id === purchaseID && (
              <Loader
                className="font-size-sm ml-2 mt-1"
                size={{ width: '16px' as any, height: '16px' as any }}
              />
            )}
          </span>
        </Button>
      ) : (
        <span className="text-muted text-nowrap" style={{ fontSize: '11px' }}>
          Receipt not available
        </span>
      ),
  }));

  const columns = [
    {
      title: 'S.N.',
      dataIndex: 'sn',
      key: 'sn',
      width: 10,
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Order Type',
      dataIndex: 'order_type',
      key: 'order_type',
    },
    {
      title: 'Total Price',
      dataIndex: 'amount',
      key: 'amount',
    },
    {
      title: 'Payment Method',
      dataIndex: 'paytment_type',
      key: 'paytment_type',
    },
    {
      title: 'Payment Status',
      dataIndex: 'status',
      key: 'status',
    },
    {
      title: 'Date',
      dataIndex: 'date',
      key: 'date',
    },
    {
      title: 'Remarks',
      dataIndex: 'invoice',
      key: 'invoice',
    },
  ];

  const handlePagination = (page, pageSize) => {
    dispatch(
      setPaymentQuerytData({
        name: 'purchaseHistory',
        value: { ...purchaseHistory, page: page },
      })
    );
  };
  return (
    <>
      <h3 className="text-dark mb-3">
        <img
          src={'/images/svgs/dashboard/order stroke.svg'}
          width={'32px'}
          height="32px"
        />
        Purchase History
      </h3>
      <div>
        <Table
          className="mt-5 mb-3 overflow-auto"
          dataSource={dataSource}
          columns={columns}
          pagination={false}
          loading={{
            indicator: (
              <div>
                <Loader />
              </div>
            ),
            spinning: getPurchaseHistoryStatus === 'request',
          }}
        />
        {getPurchaseHistoryStatus === 'success' && data.length !== 0 && (
          <Pagination
            className="text-center"
            current={meta?.page}
            total={meta?.total}
            onChange={handlePagination}
            showSizeChanger={false}
          />
        )}
      </div>
    </>
  );
};

export default PurchaseHistoryComponent;
